import React, { Component, useState, useEffect } from "react";
import { Nav, Navbar, FormControl, InputGroup, Tab, Tabs, Button, Container, ListGroup, Row, Col, Image} from "react-bootstrap";
import "./sharelist.scss";
import User from "../../common/user/user";
import SharedUser from "./sharedUser";
import ApiV2 from "../../common/apiV2";
import defaultPhoto from "../../images/default.png";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

function Shares(props) {
    const [search, setSearch] = useState("")
    const [searchResult, setSearchResult] = useState([])
    const [requests, setRequests] = useState({})
    const [inProfile, setInProfile] = useState(true);
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        try {
            fetchCollectionShares();

        } catch (error) {
            console.log("Unable to retrieve shared friends", error);
        }
        setFlag(false);
    },[flag]);

    useEffect(() => {
        if (search === ""){
            setSearchResult([]);
        } else {
            fetchUsers();
        }

    },[search]);

    const resetSearch = () => {
        setSearchResult([]);
    } 

    const fetchUsers = async () => {
        const response = await ApiV2.searchFriend(search);
        console.log(response);
        setSearchResult(response);
    }

    //function to search users using the backend api call
    const fetchCollectionShares = async () => {
        const response = await ApiV2.getCollectionShares(props.selectedSharelist.data)
        setRequests([]);
        setRequests(response.data);
    }

    const getProfilePhoto = (user) =>  {
        if (user.photoURL) {
            return (user.photoURL);
        } else {
            return (defaultPhoto);
        }
    }

    const shareCollection = async (user) => {
        try {
            const response = await ApiV2.shareSharelist(user, props.selectedSharelist.data);
            props.notifyInfo(
                `Shared collection with ${user.firstName}`
            );
            setFlag(true);
            resetSearch();
        } catch (error) {
            console.log("Unable to share collection. Error: ", JSON.stringify(error));
            props.notifyFailure(
                "Failed to share collection"
            );
        }

    }

    const renderFriendSearch = () => {
        const users = searchResult?.map(user => {
            return (
                <>
                    <ListGroup.Item key={user.userId} onClick={() => shareCollection(user)} className="position-absolute w-100 py-1 px-2" style={{ zIndex: 1 }}>
                        <Row className="text-center">
                            <Col xs={3}>
                                <Image className="profile-photo" src={user.photoURL} roundedCircle />
                            </Col>
                            <Col xs={9} className="p-0 d-flex justify-content-center align-items-center">
                                <Row>
                                    <span className="friend-name">{user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1)}</span>
                                </Row>
                            </Col>
                        </Row>
                    </ListGroup.Item>
                </>
            );
        });
        return users
    }

    const renderRequests = () => {
        if (requests){
            if (Array.isArray(requests)){
                const results = requests.map(sharedUser => {
                    return(
                        <SharedUser
                            share={sharedUser}
                        />
                    )
                })
                return results;
            }
        }
    }

    //render results here
    return (
        <Container fluid className="child-container p-0">
            <Navbar expand="lg" bg="light" variant="light" sticky="top" className="top-nav nav-fill">
                <Nav>
                    <Nav.Link className="p-0">
                        <Button variant="link" onClick={() => props.history.goBack()}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </Button>
                    </Nav.Link>
                </Nav>
                <Navbar.Brand className="brand">{props.selectedSharelist.data?.name}</Navbar.Brand>
                <Nav>
                    {/* placeholder */}
                </Nav>
            </Navbar>
            <label className="mt-2 mx-3 text-muted"><strong>Share with friends</strong></label>
            <InputGroup className="px-3 mb-2" >
                <FormControl
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={search}
                    onChange={event => {
                        setSearch(event.target.value)
                    }}
                />
                <InputGroup.Append>
                    <Button 
                    variant="outline-secondary"
                    onClick={resetSearch}
                    >Clear</Button>
                </InputGroup.Append>
            </InputGroup>
            <ListGroup className="position-relative">
                {renderFriendSearch()}
            </ListGroup>
            {renderRequests()}
        </Container>
    );
}

export default withRouter(Shares);

Shares.propTypes = {
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired,
    selectedSharelist: PropTypes.object.isRequired
};
